import { License } from '@/types/graphql';

export const CASE_MANAGER_ROLE = 'Case Manager';

type WithLicenses = { licenses?: readonly License[] | null };

const isRn = (clinician: WithLicenses): boolean => !!clinician.licenses?.includes(License.RN);

// Derives a "Case Manager" role label for RN clinicians; everyone else gets no role.
export const withCaseManagerRoles = <T extends WithLicenses>(
    clinicians: T[],
): (T & { role?: string })[] =>
    clinicians.map((clinician) => ({
        ...clinician,
        role: isRn(clinician) ? CASE_MANAGER_ROLE : undefined,
    }));

// Sorts RN clinicians ahead of the rest, leaving relative order otherwise unchanged.
export const sortRnsFirst = <T extends WithLicenses>(clinicians: T[]): T[] =>
    [...clinicians].sort((a, b) => (isRn(a) ? 0 : 1) - (isRn(b) ? 0 : 1));
